export default "__VITE_ASSET__ddd04507__"